import {observer} from 'mobx-react';
import {Panel, FormLayout, TextArea} from 'shared/components';

const ActionNotes = observer(({uiState}) => {
  const {request} = uiState;

  return (
    <div className='mt3'>
      <Panel.Separator/>
      <FormLayout>
        <TextArea
          value={request.actionedNotes}
          onChange={e => request.merge({actionedNotes: e.target.value})}
          label='expenses.expense_requests.detail.Notes'
          placeholder='expenses.expense_requests.detail.Optional notes about your decision'
        />
      </FormLayout>
    </div>
  );
});

export default ActionNotes;
